import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Info from './Info';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.dev;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(Info);

export default connect(
  mapStateToProps,
)(Styled);
